var _rect, _path, _rect2, _rect3, _g, _rect4, _rect5, _g2, _rect6, _rect7, _g3, _rect8, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstruct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 168,
    viewBox: "0 0 256 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 19.5,
    fill: "#141317"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.333 34.4374V50.6667H126.667V34.4374L119.515 41.5894L117.629 39.704L128 29.3334L138.371 39.704L136.485 41.5894L129.333 34.4374Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 19.5,
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    fill: "#141317"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 126.667H50.6668V129.333H34.4375L41.5895 136.485L39.7042 138.371L29.3335 128L39.7042 117.629L41.5895 119.515L34.4375 126.667Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    fill: "#141317"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.333 133.563L136.485 126.411L138.371 128.296L128 138.667L117.629 128.296L119.515 126.411L126.667 133.563V117.333H129.333V133.563Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    fill: "#141317"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.563 126.667L214.411 119.515L216.296 117.629L226.667 128L216.296 138.371L214.411 136.485L221.563 129.333H205.333V126.667H221.563Z",
    fill: "white"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 88.5,
    width: 79,
    height: 79,
    rx: 19.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.25 33.5C206.25 31.5772 207.014 29.7331 208.374 28.3735C209.733 27.0138 211.577 26.25 213.5 26.25C215.423 26.25 217.267 27.0138 218.627 28.3735C219.986 29.7331 220.75 31.5772 220.75 33.5C220.75 33.6989 220.671 33.8897 220.53 34.0303C220.39 34.171 220.199 34.25 220 34.25C219.801 34.25 219.61 34.171 219.47 34.0303C219.329 33.8897 219.25 33.6989 219.25 33.5C219.25 31.975 218.644 30.5125 217.566 29.4341C216.488 28.3558 215.025 27.75 213.5 27.75C211.975 27.75 210.513 28.3558 209.434 29.4341C208.356 30.5125 207.75 31.975 207.75 33.5C207.75 33.6989 207.671 33.8897 207.53 34.0303C207.39 34.171 207.199 34.25 207 34.25C206.801 34.25 206.61 34.171 206.47 34.0303C206.329 33.8897 206.25 33.6989 206.25 33.5ZM223.5 39.25C222.85 39.2494 222.214 39.445 221.676 39.8112C221.565 39.2991 221.332 38.8215 220.996 38.419C220.66 38.0166 220.232 37.7013 219.748 37.5001C219.265 37.2989 218.739 37.2176 218.217 37.2633C217.695 37.309 217.192 37.4803 216.75 37.7625V33.5C216.75 32.638 216.408 31.8114 215.798 31.2019C215.189 30.5924 214.362 30.25 213.5 30.25C212.638 30.25 211.812 30.5924 211.202 31.2019C210.593 31.8114 210.25 32.638 210.25 33.5V44.375L209.309 42.8625C208.876 42.1166 208.164 41.5733 207.33 41.3521C206.497 41.1309 205.609 41.25 204.863 41.6831C204.117 42.1163 203.574 42.828 203.353 43.6617C203.132 44.4954 203.251 45.3828 203.684 46.1287L207.349 52.3787C207.452 52.545 207.615 52.6647 207.805 52.7121C207.994 52.7596 208.195 52.7312 208.364 52.633C208.533 52.5347 208.657 52.3744 208.709 52.1861C208.762 51.9979 208.739 51.7965 208.645 51.625L204.984 45.375C204.869 45.176 204.794 44.9562 204.764 44.7284C204.734 44.5005 204.75 44.269 204.809 44.047C204.929 43.5987 205.223 43.2164 205.625 42.9844C206.027 42.7523 206.504 42.6894 206.953 42.8096C207.175 42.8691 207.383 42.9717 207.565 43.1116C207.747 43.2515 207.9 43.426 208.015 43.625C208.019 43.6325 208.023 43.6396 208.028 43.6462L210.363 47.3962C210.449 47.535 210.578 47.6419 210.73 47.7007C210.882 47.7596 211.049 47.7671 211.206 47.7223C211.363 47.6775 211.501 47.5827 211.599 47.4524C211.697 47.322 211.75 47.1632 211.75 47V33.5C211.75 33.0359 211.935 32.5908 212.263 32.2626C212.591 31.9344 213.036 31.75 213.5 31.75C213.964 31.75 214.409 31.9344 214.738 32.2626C215.066 32.5908 215.25 33.0359 215.25 33.5V42C215.25 42.1989 215.329 42.3897 215.47 42.5303C215.61 42.671 215.801 42.75 216 42.75C216.199 42.75 216.39 42.671 216.53 42.5303C216.671 42.3897 216.75 42.1989 216.75 42V40.5C216.75 40.0359 216.935 39.5908 217.263 39.2626C217.591 38.9344 218.036 38.75 218.5 38.75C218.964 38.75 219.409 38.9344 219.738 39.2626C220.066 39.5908 220.25 40.0359 220.25 40.5V43C220.25 43.1989 220.329 43.3897 220.47 43.5303C220.61 43.671 220.801 43.75 221 43.75C221.199 43.75 221.39 43.671 221.53 43.5303C221.671 43.3897 221.75 43.1989 221.75 43V42.5C221.75 42.0359 221.935 41.5908 222.263 41.2626C222.591 40.9344 223.036 40.75 223.5 40.75C223.964 40.75 224.409 40.9344 224.738 41.2626C225.066 41.5908 225.25 42.0359 225.25 42.5V47C225.25 49.7663 224.338 51.6475 224.329 51.665C224.242 51.8424 224.229 52.0469 224.291 52.2341C224.354 52.4214 224.489 52.5762 224.665 52.665C224.768 52.7198 224.883 52.7489 225 52.75C225.14 52.7503 225.277 52.7116 225.396 52.6383C225.514 52.5649 225.61 52.4599 225.673 52.335C225.716 52.2475 226.751 50.1413 226.751 47V42.5C226.751 42.0731 226.667 41.6504 226.504 41.256C226.34 40.8616 226.101 40.5033 225.799 40.2015C225.497 39.8997 225.139 39.6603 224.744 39.497C224.35 39.3338 223.927 39.2498 223.5 39.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 112)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(112 112)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(200 112)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruct);
export default __webpack_public_path__ + "static/media/instruct.9093273b5d3a447833b8cd2dda017d49.svg";
export { ForwardRef as ReactComponent };